/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_PT_PT: Record<string, string> = {
    ariaAnnounceChart: 'gráfico, ${seriesCount}[number] séries',
    ariaAnnounceFlowProportionLink: 'link ${index} de ${count}, de ${from} para ${to}, ${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: 'nó ${index} de ${count}, ${description}',
    ariaAnnounceGaugeChart: 'gráfico de medidor, ${caption}',
    ariaAnnounceHierarchyChart: 'gráfico hierárquico, ${caption}',
    ariaAnnounceHierarchyDatum: 'nível ${level}[number], ${count}[number] filhos, ${description}',
    ariaAnnounceHoverDatum: '${datum}',
    ariaDescriptionLegendItem: 'Pressione Espaço ou Enter para alternar a visibilidade',
    ariaLabelAddHorizontalLine: 'Adicionar Linha Horizontal',
    ariaLabelAnnotationOptionsToolbar: 'Opções de Anotação',
    ariaLabelAnnotationSettingsDialog: 'Configurações de Anotação',
    ariaLabelColorPicker: 'Seletor de cores',
    ariaLabelFinancialCharts: 'Gráficos financeiros',
    ariaLabelLegend: 'Legenda',
    ariaLabelLegendItem: '${label}, item da legenda ${index}[number] de ${count}[number]',
    ariaLabelLegendItemUnknown: 'Item desconhecido na legenda',
    ariaLabelLegendPageNext: 'Próxima página da legenda',
    ariaLabelLegendPagePrevious: 'Página Anterior da Legenda',
    ariaLabelLegendPagination: 'Paginação da Lenda',
    ariaLabelNavigator: 'Navegador',
    ariaLabelNavigatorMaximum: 'Máximo',
    ariaLabelNavigatorMinimum: 'Mínimo',
    ariaLabelNavigatorRange: 'Intervalo',
    ariaLabelRangesToolbar: 'Intervalos',
    ariaLabelSettingsTabBar: 'Configurações',
    ariaLabelZoomToolbar: 'Ampliar',
    ariaValuePanRange: '${min}[percent0to2dp] a ${max}[percent0to2dp]',
    contextMenuDownload: 'Baixar',
    contextMenuPanToCursor: 'Mover para aqui',
    contextMenuToggleOtherSeries: 'Alternar Outras Séries',
    contextMenuToggleSeriesVisibility: 'Alternar Visibilidade',
    contextMenuZoomToCursor: 'Ampliar para aqui',
    dialogHeaderChannel: 'Canal',
    dialogHeaderDatePriceRange: 'Data e Preço',
    dialogHeaderDateRange: 'Intervalo de Datas',
    dialogHeaderFibonacciRange: 'Retração Fib',
    dialogHeaderLine: 'Linha',
    dialogHeaderPriceRange: 'Faixa de Preço',
    dialogHeaderText: 'Texto',
    dialogInputAlign: 'Alinhar',
    dialogInputColorPicker: 'Cor',
    dialogInputColorPickerAltText: 'Cor do Texto',
    dialogInputExtendAbove: 'Estender acima',
    dialogInputExtendBelow: 'Estender abaixo',
    dialogInputExtendChannelEnd: 'Estender extremidade do canal',
    dialogInputExtendChannelStart: 'Estender início do canal',
    dialogInputExtendLeft: 'Estender para a esquerda',
    dialogInputExtendLineEnd: 'Estender o fim da linha',
    dialogInputExtendLineStart: 'Estender início da linha',
    dialogInputExtendRight: 'Estender para a direita',
    dialogInputFibonacciBands: 'Bandas',
    dialogInputFibonacciBandsAltText: 'Bandas de Fibonacci',
    dialogInputFillColorPicker: 'Preencher',
    dialogInputFillColorPickerAltText: 'Cor de Preenchimento',
    dialogInputFontSize: 'Tamanho',
    dialogInputFontSizeAltText: 'Tamanho da Fonte',
    dialogInputLineStyle: 'Tracejado',
    dialogInputPosition: 'Posição',
    dialogInputReverse: 'Reverter',
    dialogInputShowFill: 'Mostrar preenchimento',
    dialogInputStrokeWidth: 'Espessura',
    dialogInputStrokeWidthAltText: 'Espessura da Linha',
    iconAltTextAlignCenter: 'Centralizar',
    iconAltTextAlignLeft: 'Esquerda',
    iconAltTextAlignRight: 'Direita',
    iconAltTextClose: 'Fechar',
    iconAltTextLineStyleDashed: 'Traço-longo',
    iconAltTextLineStyleDotted: 'Tracejado curto',
    iconAltTextLineStyleSolid: 'Sólido',
    iconAltTextPositionBottom: 'Inferior',
    iconAltTextPositionCenter: 'Centro',
    iconAltTextPositionTop: 'Topo',
    inputTextareaPlaceholder: 'Adicionar Texto',
    measurerDateRangeBars: '${value}[number] barras',
    measurerPriceRangePercent: '${value}[percent]',
    measurerPriceRangeValue: '${value}[number]',
    measurerVolume: 'Volume ${value}',
    overlayLoadingData: 'Carregando dados...',
    overlayNoData: 'Sem dados para exibir',
    overlayNoVisibleSeries: 'Nenhuma série visível',
    overlayUnsupportedBrowser: 'Versão de navegador incompatível. Por favor, atualize seu navegador.',
    seriesHistogramTooltipCount: '${yName} (contagem)',
    seriesHistogramTooltipFrequency: 'Frequência',
    seriesHistogramTooltipMean: '${yName} (média)',
    seriesHistogramTooltipSum: '${yName} (soma)',
    toolbarAnnotationsArrow: 'Seta',
    toolbarAnnotationsArrowDown: 'Seta para Baixo',
    toolbarAnnotationsArrowUp: 'Seta para cima',
    toolbarAnnotationsCallout: 'Anotação',
    toolbarAnnotationsClearAll: 'Limpar Tudo',
    toolbarAnnotationsComment: 'Comentário',
    toolbarAnnotationsDatePriceRange: 'Data e Preço',
    toolbarAnnotationsDateRange: 'Intervalo de Datas',
    toolbarAnnotationsDelete: 'Excluir',
    toolbarAnnotationsDisjointChannel: 'Canal Disjunto',
    toolbarAnnotationsDragHandle: 'Arrastar Barra de Ferramentas',
    toolbarAnnotationsFibonacciAnnotations: 'Fibonacci',
    toolbarAnnotationsFibonacciRetracement: 'Fib Retrocesso',
    toolbarAnnotationsFibonacciRetracementTrendBased: 'Linha de Tendência Baseada no Fibonacci',
    toolbarAnnotationsFillColor: 'Cor de Preenchimento',
    toolbarAnnotationsHorizontalLine: 'Linha Horizontal',
    toolbarAnnotationsLineAnnotations: 'Linhas de Tendência',
    toolbarAnnotationsLineColor: 'Cor da Linha',
    toolbarAnnotationsLineStrokeWidth: 'Largura da Linha do Traço',
    toolbarAnnotationsLineStyle: 'Estilo de Linha',
    toolbarAnnotationsLock: 'Bloquear',
    toolbarAnnotationsMeasurerAnnotations: 'Medidores',
    toolbarAnnotationsNote: 'Nota',
    toolbarAnnotationsParallelChannel: 'Canal Paralelo',
    toolbarAnnotationsPriceRange: 'Intervalo de Preços',
    toolbarAnnotationsQuickDatePriceRange: 'Medir',
    toolbarAnnotationsSettings: 'Configurações',
    toolbarAnnotationsShapeAnnotations: 'Setas',
    toolbarAnnotationsText: 'Texto',
    toolbarAnnotationsTextAnnotations: 'Anotações de Texto',
    toolbarAnnotationsTextColor: 'Cor do Texto',
    toolbarAnnotationsTextSize: 'Tamanho do Texto',
    toolbarAnnotationsTrendLine: 'Linha de Tendência',
    toolbarAnnotationsUnlock: 'Desbloquear',
    toolbarAnnotationsVerticalLine: 'Linha Vertical',
    toolbarRange1Month: '1M',
    toolbarRange1MonthAria: '1 mês',
    toolbarRange1Year: '1A',
    toolbarRange1YearAria: '1 ano',
    toolbarRange3Months: '3M',
    toolbarRange3MonthsAria: '3 meses',
    toolbarRange6Months: '6M',
    toolbarRange6MonthsAria: '6 meses',
    toolbarRangeAll: 'Tudo',
    toolbarRangeAllAria: 'Tudo',
    toolbarRangeYearToDate: 'YTD',
    toolbarRangeYearToDateAria: 'Ano até a data',
    toolbarSeriesTypeCandles: 'Velas',
    toolbarSeriesTypeDropdown: 'Tipo de Gráfico',
    toolbarSeriesTypeHighLow: 'Alta Baixa',
    toolbarSeriesTypeHLC: 'HLC',
    toolbarSeriesTypeHollowCandles: 'Velas Vazadas',
    toolbarSeriesTypeLine: 'Linha',
    toolbarSeriesTypeLineWithMarkers: 'Linha com Marcadores',
    toolbarSeriesTypeOHLC: 'OHLC',
    toolbarSeriesTypeStepLine: 'Linha com passos',
    toolbarZoomPanEnd: 'Deslocar para o fim',
    toolbarZoomPanLeft: 'Mover para a esquerda',
    toolbarZoomPanRight: 'Mover para a direita',
    toolbarZoomPanStart: 'Mover para o início',
    toolbarZoomReset: 'Redefinir o zoom',
    toolbarZoomZoomIn: 'Aproximar',
    toolbarZoomZoomOut: 'Afastar',
    tooltipPaginationStatus: '${index}[number] de ${count}[number]',
};
